import Image from "next/image";
import { resolveImageAlt } from "../../lib/imageAlt";

export function Images(props) {
	const resolvedAlt = resolveImageAlt({
		src: props.src,
		alt: props.alt,
		decorative: props.decorative === true,
	});

	return (
		<Image
			unoptimized
			src={props.src}
			alt={resolvedAlt}
			aria-hidden={props.decorative === true ? "true" : undefined}
			width={props.width}
			height={props.height}
			style={{
				maxWidth: "100%",
				height: "auto",
			}}
		/>
	);
}

export default Images;
